import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
const CompanyRegistration = lazy(() => import("../pages/CompanyRegistration"));

export const companyRegistrationRoute = [
      {
        path: "/company-registration",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <CompanyRegistration />
          </Suspense>
        ),
      },
   
 
];
